import styled from "styled-components"
import { CalendarIcon } from "../../assets/svg/calendarIcon"

export const AddIconDatePicker = ({ height = 18, width = 17, fill = "#000", ...props }: any) => {
    return <CustomAddPicker className="relative" >
        {props.children}
        <div className="absolute top-[10px] left-[10px]">
            <CalendarIcon fill="gray" />
        </div>
    </CustomAddPicker>
}

export const AddIconCurrencyInput = ({ height = 18, width = 17, fill = "#000", ...props }: any) => {
    return <CustomInputSign className="relative" >
        {props.children}
        <div className="absolute top-[8px] left-[10px] text-[14px] text-[#72818d]">
            $
        </div>
    </CustomInputSign>
}

const CustomAddPicker = styled.div`
.react-datepicker__input-container{
    input {
        padding-left: 34px !important;
    }
    touch-action: none !important;

}
`
const CustomInputSign = styled.div`
.react-datepicker__input-container{
    input {
        padding-left: 34px !important;
    }
}
`

export const AddIconDatePickerBlack = ({ height = 18, width = 17, fill = "#000", ...props }: any) => {
    return <CustomAddPicker className="relative" >
        {props.children}
        <div className="absolute top-[10px] left-[10px]">
            <CalendarIcon fill="black" />
        </div>
    </CustomAddPicker>
}